import ApiService from '@/services/api.service';
import {
  DEFAULT_MAIL_FETCH_RULES,
  normalizeMailFetchRules,
  toMailFetchSettingsPayload,
} from '@/modules/vendor/utils/mailInboxFetchRules';

const mailFetchSettingsService = {
  async getSettings(companyId) {
    const response = await ApiService.get(`/company/${companyId}/mail-fetch-settings`);
    return normalizeMailFetchRules(response.data?.data || DEFAULT_MAIL_FETCH_RULES);
  },

  async saveSettings(companyId, rules) {
    const payload = toMailFetchSettingsPayload(rules);
    const response = await ApiService.put(`/company/${companyId}/mail-fetch-settings`, payload);
    return normalizeMailFetchRules(response.data?.data);
  },
};

export default mailFetchSettingsService;
